import { useMutation } from "@apollo/react-hooks";
import { Text } from "@skodel/sk-ui";
import { Button, ModalCloseButton, Modal } from "@skodel/sk-ui";
import { loader } from "graphql.macro";
import React from "react";
import { toast } from "react-toastify";

const DeleteAccount = loader("./DeleteAccount.graphql");

const DeleteAccountModal = ({
  isOpen,
  onClose,
  account,
  ...otherProps
}: any) => {
  const [deleteAccount, deleteAccountState] = useMutation(DeleteAccount);

  return (
    <Modal.Base
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Delete Account"
    >
      <Modal.Header>
        <Text>Deleting Account</Text>

        <ModalCloseButton onClose={onClose} />
      </Modal.Header>
      <Modal.Body>
        <Text>
          Are you sure you want to delete {account.name}? This includes all
          users and data related to them and is irreversible.
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" mr="2" onClick={onClose}>
          No
        </Button>
        <Button
          disabled={deleteAccountState.loading}
          onClick={() => {
            deleteAccount({
              variables: {
                id: account.id,
              },
              refetchQueries: ["GetAccounts"],
            })
              .then((response: any) => {
                if (response.data.deleteAccount.success) {
                  toast.success("Successfully deleted account.");

                  onClose();
                } else {
                  if (
                    response.data.deleteAccount.__typename ===
                    "NoSuchObjectError"
                  ) {
                    toast.error(response.data.deleteAccount.message);
                  } else {
                    toast.error(
                      "Could not delete account. Please check your internet connection and try again."
                    );
                  }
                }
              })
              .catch((err: any) =>
                toast.error(
                  "Could not delete account. Please check your internet connection and try again."
                )
              );
          }}
        >
          Yes
        </Button>
      </Modal.Footer>
    </Modal.Base>
  );
};

export default DeleteAccountModal;
